import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import WelcomePageForm from "./WelcomePageForm";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: "50px", // space for fixed footer
  },
}));

function WelcomePage(props) {
  useEffect(() => {}, []);

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <WelcomePageForm />
    </div>
  );
}

export default WelcomePage;
